import { FC, useCallback, useMemo } from 'react';
import { FieldProps } from 'react-admin';
import { useController } from 'react-hook-form';
import { Box, Typography } from '@mui/material';
import { useLogEffect } from '@/util/useLogEffect';
import { TagEditor } from './TagTextEditor';

type TagInputProps = Omit<FieldProps, 'source'> & {
  source: string;
  placeholder?: string;
  tagRegex?: RegExp;
  validTags?: string[];
  validateTag?: (tagName: string) => boolean;
};

export const TagInput: FC<TagInputProps> = ({
  source,
  label,
  placeholder,
  validTags,
}) => {
  const { field } = useController({ name: source, defaultValue: '' });

  // Add debugging
  useLogEffect('TagInput received props :: validTags', validTags);
  useLogEffect(
    'TagInput received props :: validTags length',
    validTags?.length,
  );

  const handleChange = useCallback(
    (event: any, newValue: string) => {
      // console.log("TagInput handleChange", newValue);
      field.onChange(newValue);
    },
    [field],
  );

  const boxStyles = useMemo(
    () => ({
      width: '100%',
      marginBottom: '2rem',
    }),
    [],
  );

  return (
    <Box sx={boxStyles}>
      {label && (
        <Typography variant="body2" color="text.secondary" mb={1}>
          {label as string}
        </Typography>
      )}
      <TagEditor
        value={field.value || ''}
        onChange={handleChange as any}
        onBlur={field.onBlur}
        validTags={validTags || []}
        placeholder={placeholder}
      />
    </Box>
  );
};
